/* istanbul ignore file */
export default {
  // Extracted from configStrings in OSG
  ALLOWED_ACTIONS: {
    REMOVE: 'RM',
    ADD: 'AD',
    UPDATE: 'UP',
    SUSPEND: 'SU',
    RESUME: 'RS'
  },
  DEFAULT_SHOW_ADDONS_COUNT: 5,
  FAMILYPLAN: 'FAMILYPLAN'
};
